import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import { message, Button, Result } from 'antd';
import { getUser } from '../../../../services/user';
import { updatePassword } from '../../../../services/user';
import UnifiedDashboard from '../../../../components/layout/unified-dashboard';

const UpdatePassword = ({ match }) => {
  const [values, setValues] = useState({
    oldPassword: '',
    password: '',
    newPasswordConfirm: '',
    userId: '',
    userAuth: '',
  });

  const { oldPassword, password, newPasswordConfirm, userId } = values;
  const { user, token } = isAuthenticated();

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    let res = await getUser(match.params.userId);
    setValues({ ...values, userId: res.data._id, userAuth: user._id });
  };

  const handleChange = (name) => (event) => {
    const value = event.target.value;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(values);

    try {
      const res = await updatePassword(
        match.params.userId,
        JSON.stringify(values),
        token
      );
      console.log(res);
      //   window.location.reload();
      setValues({
        ...values,
        password: '',
        oldPassword: '',
        newPasswordConfirm: '',
      });
      message.success('Password updated successfully', 4);
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) message.error(err.response.data, 4);
    }
  };

  const updatePasswordForm = () => (
    <div className='card rounded-0 pb-5 card-shadow'>
      <div className='card-header p-4'>
        <h2 className='text-center'>
          <i className='fas fa-user-edit'></i> Atualize sua senha
        </h2>
      </div>
      <div className='card-body'>
        <form onSubmit={handleSubmit}>
          <div className='form-group mb-4 col-md-8 mx-auto'>
            <label className='form-label'>Senha atual</label>
            <input
              type='password'
              className='form-control shadow-none rounded-0'
              placeholder='Digite sua senha atual'
              value={oldPassword}
              onChange={handleChange('oldPassword')}
            />
          </div>
          <div className='form-group mb-4 col-md-8 mx-auto'>
            <label className='form-label'>Nova senha</label>
            <input
              type='password'
              className='form-control shadow-none rounded-0'
              placeholder='Digite a nova senha'
              value={password}
              onChange={handleChange('password')}
            />
          </div>
          <div className='form-group mb-4 col-md-8 mx-auto'>
            <label className='form-label'>Confirme a nova senha</label>
            <input
              type='password'
              className='form-control shadow-none rounded-0'
              placeholder='Repita a nova senha'
              value={newPasswordConfirm}
              onChange={handleChange('newPasswordConfirm')}
            />
          </div>
          <div className='mx-auto col-md-8'>
            <Button
              type='primary'
              size='large'
              shape='round'
              className='rounded-0'
              htmlType='submit'
            >
              Atualizar Senha
            </Button>
          </div>
        </form>
      </div>
    </div>
  );

  return (
    <UnifiedDashboard>
      <div className='update-password-content dashboard-content'>
        <div className='update-password-card card rounded-3 card-shadow'>
          <div className='card-header p-4 bg-white border-bottom-0'>
            <h2 className='text-center mb-0'>Alterar Senha</h2>
          </div>
          <div className='card-body'>{updatePasswordForm()}</div>
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default UpdatePassword;
